// Auto-curated Uge Appage SMP Episode Archive
// Preserves complete chronological history from oldest classic / reborn streams to latest Season 3 episodes

export interface Episode {
  id: string;
  title: string;
  creator: string;
  published: string;
  length: string;
  isLive: boolean;
  season: number;
  tag: string;
  thumbnail: string;
  url: string;
}

export const EPISODES_DATA: Episode[] = [
  {
    "id": "hTzP0N0eYeU",
    "title": "Uge Appage SMP Reborn | Official Trailer",
    "creator": "MR.Senura",
    "published": "3 yr ago",
    "length": "1:38",
    "isLive": false,
    "season": 1,
    "tag": "Trailer",
    "thumbnail": "https://i.ytimg.com/vi/hTzP0N0eYeU/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=hTzP0N0eYeU"
  },
  {
    "id": "SrdmSbG4NB8",
    "title": "No Port City Official Trailer | Uge Appage SMP",
    "creator": "Hiru X Gaming",
    "published": "3 yr ago",
    "length": "1:31",
    "isLive": false,
    "season": 1,
    "tag": "Trailer",
    "thumbnail": "https://i.ytimg.com/vi/SrdmSbG4NB8/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=SrdmSbG4NB8"
  },
  {
    "id": "rhS7BPj31p8",
    "title": "Uge Appage SMP Reborn | Official Trailer",
    "creator": "Hiru X Gaming",
    "published": "3 yr ago",
    "length": "1:38",
    "isLive": false,
    "season": 1,
    "tag": "Trailer",
    "thumbnail": "https://i.ytimg.com/vi/rhS7BPj31p8/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=rhS7BPj31p8"
  },
  {
    "id": "CZwLhSFBCrI",
    "title": "Uge Appage SMP Reborn | Official Trailer",
    "creator": "SL_Tharu",
    "published": "3 yr ago",
    "length": "1:38",
    "isLive": false,
    "season": 1,
    "tag": "Trailer",
    "thumbnail": "https://i.ytimg.com/vi/CZwLhSFBCrI/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=CZwLhSFBCrI"
  },
  {
    "id": "njdavTX9auc",
    "title": "ගම ගොඩනැගීම | Uge Appage SMP | Day  2 | Jabuu.x",
    "creator": "Jabuu.x",
    "published": "Streamed 3 yr ago",
    "length": "40:58",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/njdavTX9auc/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=njdavTX9auc"
  },
  {
    "id": "qlwNJ_99H9U",
    "title": "🔴නව ආරම්භයක් | Uge Appage SMP | Minecraft | EP 5",
    "creator": "Hiru X Gaming",
    "published": "Streamed 3 yr ago",
    "length": "1:44:24",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/qlwNJ_99H9U/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=qlwNJ_99H9U"
  },
  {
    "id": "__wn5wV2GSU",
    "title": "🔴යාලුවෝ සොයා | Uge Appage SMP | Minecraft | EP 6",
    "creator": "Hiru X Gaming",
    "published": "Streamed 3 yr ago",
    "length": "1:51:31",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/__wn5wV2GSU/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=__wn5wV2GSU"
  },
  {
    "id": "ouSs62vBTG8",
    "title": "🔴අලුත් ගමේ ආරම්භය | Uge Appage SMP | Minecraft | EP 7",
    "creator": "Hiru X Gaming",
    "published": "Streamed 3 yr ago",
    "length": "3:11:38",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/ouSs62vBTG8/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=ouSs62vBTG8"
  },
  {
    "id": "--1CH0NEoHU",
    "title": "🔴No Port City ආරම්භය | Uge Appage SMP | Minecraft | EP 8",
    "creator": "Hiru X Gaming",
    "published": "Streamed 3 yr ago",
    "length": "2:02:52",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/--1CH0NEoHU/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=--1CH0NEoHU"
  },
  {
    "id": "Jzf1W1xM3Gs",
    "title": "Uge Appage SMP Reborn | නව ආරම්භයක්  | Jabuu.x",
    "creator": "Jabuu.x",
    "published": "Streamed 3 yr ago",
    "length": "42:44",
    "isLive": true,
    "season": 1,
    "tag": "Reborn",
    "thumbnail": "https://i.ytimg.com/vi/Jzf1W1xM3Gs/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=Jzf1W1xM3Gs"
  },
  {
    "id": "IDU8p-kCqqM",
    "title": "The Truth | Uge appage SMP | Minecraft",
    "creator": "SL_Tharu",
    "published": "3 yr ago",
    "length": "4:48",
    "isLive": false,
    "season": 1,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/IDU8p-kCqqM/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=IDU8p-kCqqM"
  },
  {
    "id": "pEJpViZZqiA",
    "title": "Uge appage smp part - ii",
    "creator": "Jabuu.x",
    "published": "Streamed 3 yr ago",
    "length": "1:02:36",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/pEJpViZZqiA/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=pEJpViZZqiA"
  },
  {
    "id": "rl4yM0ustqE",
    "title": "haaaaai | Uge Appage SMP | Minecraft",
    "creator": "SL_Tharu",
    "published": "Streamed 3 yr ago",
    "length": "2:26:35",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/rl4yM0ustqE/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=rl4yM0ustqE"
  },
  {
    "id": "cHpINogxqpA",
    "title": "පින්බර වෙසක් මංගල්‍යක් වේවා | Uge Appage SMP",
    "creator": "Hiru X Gaming",
    "published": "3 yr ago",
    "length": "0:31",
    "isLive": false,
    "season": 1,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/cHpINogxqpA/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=cHpINogxqpA"
  },
  {
    "id": "YXDoW4fT7Io",
    "title": "kauda malli meh | Uge Appage SMP | Minecraft",
    "creator": "SL_Tharu",
    "published": "Streamed 3 yr ago",
    "length": "1:15:03",
    "isLive": true,
    "season": 1,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/YXDoW4fT7Io/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=YXDoW4fT7Io"
  },
  {
    "id": "Dgg4W55VBFE",
    "title": "The Truth | Uge Appage SMP | Chapter 3",
    "creator": "Hiru X Gaming",
    "published": "3 yr ago",
    "length": "4:48",
    "isLive": false,
    "season": 1,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/Dgg4W55VBFE/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=Dgg4W55VBFE"
  },
  {
    "id": "s0lhxkfCxx0",
    "title": "Appage gama | Uge Appage SMP |Minecraft| #SL_Tharu",
    "creator": "SL_Tharu",
    "published": "Streamed 3 mo ago",
    "length": "1:24:49",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/s0lhxkfCxx0/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=s0lhxkfCxx0"
  },
  {
    "id": "6oLQ5RqCgHs",
    "title": "Ape Gama |Uge Appage SMP |Minecraft | #SL_Tharu",
    "creator": "SL_Tharu",
    "published": "Streamed 3 mo ago",
    "length": "1:52:50",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/6oLQ5RqCgHs/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=6oLQ5RqCgHs"
  },
  {
    "id": "MqnXmMX8Vpk",
    "title": "🔴ආරම්භය කඳුලක්! 😭💔 | Uge Appa SMP l S03 EP 01 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 1 mo ago",
    "length": "2:50:48",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/MqnXmMX8Vpk/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=MqnXmMX8Vpk"
  },
  {
    "id": "56oFykPGJgk",
    "title": "🔴අලුත් තැනකට 😱🌲 | Uge Appa SMP l S03 EP 02 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 1 mo ago",
    "length": "4:41:30",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/56oFykPGJgk/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=56oFykPGJgk"
  },
  {
    "id": "HuCpB4DRST0",
    "title": "🔴Farming ජිවිත🌲 | Uge Appa SMP l S03 EP 03 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 1 mo ago",
    "length": "1:42:59",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/HuCpB4DRST0/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=HuCpB4DRST0"
  },
  {
    "id": "DQsCRv8oOu4",
    "title": "🔴Nether එකට යමු! 😈🌋 | Uge Appa SMP l S03 EP 04 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 1 mo ago",
    "length": "1:30:30",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/DQsCRv8oOu4/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=DQsCRv8oOu4"
  },
  {
    "id": "-_5htFlHhXo",
    "title": "🔴මේක අපිලගේ රට🌋 | Uge Appa SMP l S03 EP 05 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 1 mo ago",
    "length": "2:18:03",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/-_5htFlHhXo/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=-_5htFlHhXo"
  },
  {
    "id": "hCTPqfSpa50",
    "title": "Glory of Legends 🏆 | Uge Appa SMP",
    "creator": "Hiru X Gaming",
    "published": "1 mo ago",
    "length": "3:37",
    "isLive": false,
    "season": 3,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/hCTPqfSpa50/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=hCTPqfSpa50"
  },
  {
    "id": "WOhDrd6QWB0",
    "title": "🔴අලුත් ගමේ ආරම්භය | Uge Appa SMP l S03 EP 06 🇱🇰",
    "creator": "Hiru X Gaming",
    "published": "Streamed 3 wk ago",
    "length": "2:05:55",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/WOhDrd6QWB0/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=WOhDrd6QWB0"
  },
  {
    "id": "3XxZSTLdiUE",
    "title": "UGE APPA SMP – SEASON 3 IS HERE 🔥",
    "creator": "Hiru X Gaming",
    "published": "3 wk ago",
    "length": "1:47",
    "isLive": false,
    "season": 3,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/3XxZSTLdiUE/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=3XxZSTLdiUE"
  },
  {
    "id": "3vugymOKxFs",
    "title": "Uge Appage SMP Trailer (Season 3)",
    "creator": "Official",
    "published": "2 wk ago",
    "length": "1:47",
    "isLive": false,
    "season": 3,
    "tag": "Trailer",
    "thumbnail": "https://i.ytimg.com/vi/3vugymOKxFs/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=3vugymOKxFs"
  },
  {
    "id": "HIiFipafzfI",
    "title": "ගමේ සවාරිය | Uge Appage SMP | S03 EP 01",
    "creator": "Jabuu.x",
    "published": "Streamed 2 wk ago",
    "length": "1:28:48",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/HIiFipafzfI/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=HIiFipafzfI"
  },
  {
    "id": "iq0QSUw2eK8",
    "title": "පෙට්ටි සොයා අවසානයට | Uge Appage SMP | S03 EP 02",
    "creator": "Jabuu.x",
    "published": "Streamed 2 wk ago",
    "length": "1:55:06",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/iq0QSUw2eK8/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=iq0QSUw2eK8"
  },
  {
    "id": "Vi5D-NIELL4",
    "title": "🔴ගම හදමු | Uge Appa SMP l S03 EP 07",
    "creator": "Hiru X Gaming",
    "published": "Streamed 2 wk ago",
    "length": "2:25:05",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/Vi5D-NIELL4/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=Vi5D-NIELL4"
  },
  {
    "id": "nZFBW4XrHko",
    "title": "🔴ගොවියෙක් වීමේ පළමු පියවර | Uge Appa SMP l S03 EP 08",
    "creator": "Hiru X Gaming",
    "published": "Streamed 2 wk ago",
    "length": "1:45:37",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/nZFBW4XrHko/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=nZFBW4XrHko"
  },
  {
    "id": "MUdIQqxRc8U",
    "title": "Uge Appage SMP",
    "creator": "WJ Biman - Topic",
    "published": "",
    "length": "1:37",
    "isLive": false,
    "season": 3,
    "tag": "Episode",
    "thumbnail": "https://i.ytimg.com/vi/MUdIQqxRc8U/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=MUdIQqxRc8U"
  },
  {
    "id": "tUj_z2Zfwk0",
    "title": "Vanilla පෙරේතයෙක් මි.  | Uge Appage SMP | S03 EP 03",
    "creator": "Jabuu.x",
    "published": "Streamed 1 day ago",
    "length": "2:14:02",
    "isLive": true,
    "season": 3,
    "tag": "Live Stream",
    "thumbnail": "https://i.ytimg.com/vi/tUj_z2Zfwk0/hqdefault.jpg",
    "url": "https://www.youtube.com/watch?v=tUj_z2Zfwk0"
  }
];
